var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInbox = function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12.88V2.25A1.5 1.5 0 0 0 18 .75H6a1.5 1.5 0 0 0-1.5 1.5v10.63m3.75-7.63h3m-3 3h7.5m-7.5 3h7.5m5.534.215a.75.75 0 0 1 1.216.587v9.7a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5v-9.7a.75.75 0 0 1 1.216-.587l7.431 5.894a3 3 0 0 0 3.706 0z"
  })));
};
export default SvgInbox;